import {publicConfigActionTypes} from './publicConfig.types';

export const fetchPublicConfig = (targetGroupId) => ({
    type: publicConfigActionTypes.FETCH_PUBLIC_CONFIG,
    payload: { targetGroupId },
});
